// store/outbound/slice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OutboundCampaign, OutboundState } from '@/types/TOutbound';

const initialState: OutboundState = {
	campaigns: {},
	currentCampaign: null,
};

export const outboundSlice = createSlice({
	name: 'outbound',
	initialState,
	reducers: {
		setCampaigns: (state, action: PayloadAction<OutboundCampaign[]>) => {
			state.campaigns = {};
			action.payload.forEach((campaign) => {
				if (campaign.id) {
					state.campaigns[campaign.id] = campaign;
				}
			});
		},

		addCampaign: (state, action: PayloadAction<OutboundCampaign>) => {
			if (action.payload.id) {
				state.campaigns[action.payload.id] = action.payload;
			}
		},

		updateCampaign: (
			state,
			action: PayloadAction<{ id: string; data: Partial<OutboundCampaign> }>,
		) => {
			const { id, data } = action.payload;
			if (state.campaigns[id]) {
				state.campaigns[id] = { ...state.campaigns[id], ...data };
			}
		},

		removeCampaign: (state, action: PayloadAction<string>) => {
			delete state.campaigns[action.payload];
			if (state.currentCampaign?.id === action.payload) {
				state.currentCampaign = null;
			}
		},

		setCurrentCampaign: (state, action: PayloadAction<OutboundCampaign | null>) => {
			state.currentCampaign = action.payload;
		},

		updateCurrentCampaign: (state, action: PayloadAction<Partial<OutboundCampaign>>) => {
			if (state.currentCampaign) {
				state.currentCampaign = { ...state.currentCampaign, ...action.payload };
			}
		},

		resetCurrentCampaign: (state) => {
			state.currentCampaign = null;
		},

		resetAll: () => initialState,
	},
});

export const {
	setCampaigns,
	addCampaign,
	updateCampaign,
	removeCampaign,
	setCurrentCampaign,
	updateCurrentCampaign,
	resetCurrentCampaign,
	resetAll,
} = outboundSlice.actions;

export default outboundSlice.reducer;
